import { type ReactNode, useCallback } from "react";

import { useUserContext } from "@/context/user.context";

interface InternalOnlyRenderConfig {
  additionalConditional?: boolean | (() => boolean);
  fallback?: ReactNode;
}

const defaultConfig: InternalOnlyRenderConfig = {
  additionalConditional: true,
  fallback: null,
};

export type InternalOnlyRender = (
  ui: ReactNode,
  config?: InternalOnlyRenderConfig,
) => ReactNode;

export const useGetInternalOnlyRender = () => {
  const { isInternal } = useUserContext();

  return useCallback<InternalOnlyRender>(
    (ui, config = defaultConfig) => {
      const { additionalConditional = true, fallback = null } = config;
      const conditionalResult =
        typeof additionalConditional === "function"
          ? additionalConditional()
          : additionalConditional;

      return isInternal && conditionalResult ? ui : fallback;
    },
    [isInternal],
  );
};
